import { styled } from '@linaria/react';
import { PopTopicCategory } from '@fe-news/constants/pop-topic/type';
import { PopTopicTags } from '@fe-news/constants/pop-topic/default-value';

const Tag = styled.div<{ backgroundColor?: string }>`
  border-radius: 6px;
  padding: 3px 8px;
  background-color: ${({ backgroundColor }) => backgroundColor || '#007aff'};
  font-size: 14px;
  font-weight: 500;
  color: #fff;
`;

type PopTopicGroupTagsProps = {
  tag: PopTopicCategory;
};

const PopTopicTag: React.FC<PopTopicGroupTagsProps> = ({ tag }) => {
  return <Tag backgroundColor={PopTopicTags[tag.slug]?.color}>{PopTopicTags[tag.slug]?.name ?? tag.name}</Tag>;
};

export default PopTopicTag;
